import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router';
import { selectedDateWithoutTime } from '@store/global/selectors';
import { selectValidParams, selectDateRange, selectGridData, selectShowReasonColumn } from '@pages/reporting-pages/reduced-orders/store/selectors';
import { ReducedParams } from '@api/order-reporting/types/ReducedParams';
import { setSearchParameters, setDateRange } from '@pages/reporting-pages/reduced-orders/store/slice';
import { DateRange } from '@project-types/DateRange';
import { useResetReducedOrdersMutation } from '@api/order-reporting/api';
import { AppPage } from 'components/app-page/AppPage';
import ParamsToolbar from '@pages/reporting-pages/reduced-orders/params-toolbar/ParamsToolbar';
import Grid from '@pages/reporting-pages/reduced-orders/grid/Grid';
import { getHeadersObject } from '@pages/reporting-pages/reduced-orders/headersObject';



const ReducedOrders = () => {
	
	const validParams = useSelector(selectValidParams);
	const dateWithoutTime = useSelector(selectedDateWithoutTime);
	const dateRange = useSelector(selectDateRange);
	const gridData = useSelector(selectGridData);
	const showReasonColumn = useSelector(selectShowReasonColumn);

	const [ search, setSearch ] = useSearchParams();
	const dispatch = useDispatch();
	const updateSearchParameters = (parameters: ReducedParams) => dispatch(setSearchParameters(parameters));
	const updateDateRange = (dateRange: DateRange) => dispatch(setDateRange(dateRange));

	const [ resetReducedOrders ] = useResetReducedOrdersMutation();


	useEffect(() => {
		if (!dateRange) {
			updateDateRange({ from: dateWithoutTime, to: dateWithoutTime });
		}
	}, []);

	
	useEffect(() => {
		if (validParams) {
			setSearch({ ...validParams }, { replace: true });
		}
	}, [ validParams ]);

	
	useEffect(() => {
		if (search) {
			let paramDateFrom = search.get('dateFrom');
			let paramDateTo = search.get('dateTo');
			let paramDc = search.get('dc');
			let paramOrderPhase = search.get('orderPhase');

			if (!paramDateFrom || !paramDateTo) return;

			let newSearchParams: ReducedParams = {
				dateFrom: paramDateFrom,
				dateTo: paramDateTo,
				...(paramDc && { dc: paramDc }),
				...(paramOrderPhase && { orderPhase: paramOrderPhase }),
			}
			updateSearchParameters(newSearchParams);
		}
	}, [ search ]);


	const resetAllApi = useCallback(() => {
		resetReducedOrders();
	},[]);


	return (
		<AppPage
			className='reporting-page reduced-orders'
			pageLabel='Report - Pokrácené objednávky'
			resetPageApi={resetAllApi}
			csvData={{
				headers: getHeadersObject(showReasonColumn),
				data: gridData,
				filename: 'reporting-pokracene-objednavky',
			}}
		>
			<ParamsToolbar />
			<Grid />
		</AppPage>
	)
};

export default ReducedOrders;